import React, { createContext, Dispatch, PropsWithChildren, Reducer, useContext, useReducer } from 'react';
import {
    AddToCartOrListActions,
    addToCartOrListInitialState,
    addToCartOrListReducer,
    AddToCartOrListState
} from './addToCartOrList/addToCartOrListReducer';
import {
    LoanFormatActions,
    loanFormatInitialState,
    loanFormatReducer,
    LoanFormatState
} from './loanFormat/loanFormatReducer';
import {
    NotificationAction,
    notificationInitialState,
    notificationReducer,
    NotificationState
} from './notification/notificationReducer';

type StateType = {
    addToCartOrList: AddToCartOrListState;
    loanFormat: LoanFormatState;
    notification: NotificationState | undefined;
};

type ActionType = AddToCartOrListActions | LoanFormatActions | NotificationAction;

// TODO re-check, if we really need a "redux-like" combined reducer (after migrating all global stuff)
const combineReducers = <T extends Record<string, Reducer<any, any>>>(reducers: T) => {
    return (state: StateType, action: ActionType) => {
        return Object.keys(reducers).reduce((nextState, key) => {
            nextState[key] = reducers[key](state[key], action);
            return nextState;
        }, {} as StateType);
    };
};

const GlobalContext = createContext<{ state: StateType; dispatch: Dispatch<ActionType> } | undefined>(undefined);

const reducers = {
    addToCartOrList: addToCartOrListReducer,
    loanFormat: loanFormatReducer,
    notification: notificationReducer
};

const initialState: StateType = {
    addToCartOrList: addToCartOrListInitialState,
    loanFormat: loanFormatInitialState,
    notification: notificationInitialState
};

export const GlobalContextProvider = ({ children }: PropsWithChildren) => {
    const [state, dispatch] = useReducer(combineReducers(reducers), initialState);

    return <GlobalContext.Provider value={{ state, dispatch }}>{children}</GlobalContext.Provider>;
};

export const useGlobalContext = () => {
    const context = useContext(GlobalContext);

    if (!context) {
        throw new Error('useGlobalContext must be used within a GlobalContextProvider');
    }

    return context;
};
